/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import cx from 'classnames';
import React, { useMemo } from 'react';

import { RowSkeleton } from '../../skeletons/RowSkeleton';
import { useFormStyles } from '../../styles/form';
import { getDummyArray } from '../../utils/getDummyArray';
import { useSystemConfigurationFormStyles } from './components/SystemConfigurationForm/SystemConfigurationForm.styles';
import { useSystemConfigurationPageStyles } from './SystemConfigurationPage.styles';

type SystemConfigurationPlaceholderProps = {
  inputs?: number;
};

export function SystemConfigurationPlaceholder(props: SystemConfigurationPlaceholderProps) {
  const classes = useSystemConfigurationPageStyles();
  const formClassesDefault = useFormStyles();
  const formClasses = useSystemConfigurationFormStyles();
  const { inputs = 0 } = props;

  const inputsDummyArray = useMemo(() => getDummyArray({ length: inputs }), [inputs]);

  return (
    <>
      <div className={classes.title}>
        <RowSkeleton width={350} height={24} />
      </div>
      <div className={formClasses.groupContainer}>
        <div>
          <RowSkeleton width={200} height={15} />
        </div>
        {inputsDummyArray.length &&
          inputsDummyArray.map(i => (
            <div key={i} className={cx(formClassesDefault.formControl, formClassesDefault.widthMedium)}>
              <RowSkeleton width={600} height={48} />
            </div>
          ))}
      </div>
      <div className={classes.submitBtn}>
        <RowSkeleton width={140} height={40} />
      </div>
    </>
  );
}
